<template>
  <div class="wrapper">
    <!-- <i class="material-icons align-middle check">alert_circle</i> -->
    <img src="/alert.svg" style="align-self: flex-start; margin-right: 16px" />
    <div class="detail-wrapper">
      <div class="title">Project proposal</div>
      <div class="content">
        Here’s your project decription and anonymized candidates that could fit
        your project. To go to the next step and see full resumes along with
        video interviews, sign an short agreement/proposal with a non-solicit to
        hire people from our platform. There is no payment required unless you
        pick one of our consultants.
      </div>
      <button class="proposal-button">
        <img src="/global.svg" />
        <div>Sign Proposal</div>
      </button>
    </div>
    <div class="close-wrapper">
      <i class="material-icons align-middle">close</i>
    </div>
  </div>
</template>

<script>
export default {
  props: ["url"],
  methods: {
    onClose: function () {
      this.$emit("onClose");
    },
  },
};
</script>


<style scoped>
.wrapper {
  padding: 20px 60px 20px 24px;
  background: rgba(0, 133, 255, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  position: relative;
}
.check {
  font-size: 48px;
  margin-right: 20px;
  color: #00ba34;
}
.detail-wrapper {
  flex-grow: 1;
}
.title {
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  font-family: inter-regular;
  color: #1c1c1c;
}
.content {
  font-size: 16px;
  line-height: 24px;
  color: #585757;
}
.close-wrapper {
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 20px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.proposal-button {
  all: unset;
  background: #0085ff;
  border-radius: 8px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin-top: 12px;
  color: #ffffff;
  cursor: pointer;
}
.proposal-button > img {
  margin-right: 8px;
}
</style>
